/* Boost AI 商品一覧: 戻り時のスクロール位置復元 と page=N の扱い
 *
 * content_for_header より前に同期実行される前提（Boost 本体・customization.js より先）。
 *
 * 2モード:
 * ┌ 戻り(SPEED)モード: 商品カードをクリックして詳細に入り「戻る」で一覧へ来た時。
 * │  bfcache ヒットなら pageshow で即復元。bfcache ミス(=フルリロード, PC で拡張機能により
 * │  bfcache が無効化される等)の場合、全ページ再取得は重いので **見ていた商品のページだけ**を
 * │  Boost にネイティブ読み込みさせ(1フェッチ)、その商品へ即スクロールする。
 * └ 通常(FULL)モード: page=N の直リンク/リロード等(商品クリック由来でない)。従来どおり
 *    page= を外して page1 から「もっと見る」を自動押下し page1..N を全部表示する。
 *
 * 背景の注意:
 * - このストアの Boost(旧実装)は「前のページを読み込む」(prepend)後に「もっと見る」を押すと
 *   既読ページを再取得して商品が重複する。FULL モードは append のみで整合させる。
 * - Boost CDN 配信の customization.js には page= を強制削除する処理が残っている。FULL モードは
 *   自前で先に page= を外すので無害だが、SPEED モードは page=N を残す必要があるため、
 *   その削除(replaceState)を一時的にブロックして無害化する。
 * - 「続けて商品を見る」(load more)は Boost が毎回 pushState で履歴を積むため、戻る複数回で
 *   中間ページに落ちて最下部へ飛ぶ。page パラメータだけ変わる遷移は replaceState に置換する。
 */
(function () {
  'use strict';

  var PRODUCT_ITEM = '.boost-sd__product-item';
  var LOAD_MORE_BTN = '.boost-sd__pagination-button--load-more';
  var LOAD_PREV_BTN = '.boost-sd__pagination-button--load-previous';
  var RETURN_KEY = 'wnBoostReturnProduct';
  var MAX_AUTO_PAGES = 20;

  var origPushState = History.prototype.pushState;
  var origReplaceState = History.prototype.replaceState;

  // ---- Boost の戻り時 scrollToTop を抑止して“トップ一瞬表示”を根本から防ぐ ----
  // Boost は back(popstate)時に domHelper.scrollToTop({}) でトップへ飛ぶ。公式フラグ
  // window.boostSdDisableScrollToTop=true でこの呼び出しをスキップさせ、復元位置を保つ
  // (後追いの scrollIntoView 補正だと1フレームだけトップが描画されるため根本予防する)。
  // 通常のフィルタ等のスクロール上昇は残すため、少し経過 or 初回操作で解除する。
  function disableBoostScrollTop() { try { window.boostSdDisableScrollToTop = true; } catch (e) {} }
  function enableBoostScrollTop() { try { window.boostSdDisableScrollToTop = false; } catch (e) {} }
  disableBoostScrollTop();
  setTimeout(enableBoostScrollTop, 2500);
  // 戻り(popstate)時は Boost のハンドラより前(capture)に再度抑止する(bfcache 復帰含む)
  window.addEventListener('popstate', function () {
    disableBoostScrollTop();
    setTimeout(enableBoostScrollTop, 1500);
  }, true);

  function getUrlPage() {
    try {
      var n = parseInt(new URLSearchParams(location.search).get('page'), 10);
      return n > 1 ? n : 1;
    } catch (e) { return 1; }
  }

  // ---- 戻り(SPEED)判定: 商品クリック記録があり back_forward で戻ってきたか ----
  function readReturnTarget() {
    try {
      var raw = sessionStorage.getItem(RETURN_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      var nav = performance.getEntriesByType('navigation')[0];
      var isBack = nav && nav.type === 'back_forward';
      if (!isBack || data.path !== location.pathname || Date.now() - data.ts > 30 * 60 * 1000) return null;
      return data;
    } catch (e) { return null; }
  }

  var urlPage = getUrlPage();
  var returnTarget = readReturnTarget();
  var speedMode = !!returnTarget; // 商品から戻ってきた
  // SPEED は returnTarget.page(クリック時の URL ページ)を使う。無ければ URL ページ。
  var targetPage = speedMode ? Math.min(Math.max(returnTarget.page || urlPage, 1), MAX_AUTO_PAGES)
                             : Math.min(urlPage, MAX_AUTO_PAGES);

  // ---- ページ送り(page=)の履歴を積ませない(戻る複数回で最下部に飛ぶのを防止) ----
  History.prototype.pushState = function (state, title, urlArg) {
    if (urlArg != null) {
      try {
        var next = new URL(String(urlArg), location.href);
        var cur = new URL(location.href);
        if (next.pathname === cur.pathname && onlyPageParamDiffers(cur, next)) {
          return origReplaceState.call(this, state, title, urlArg);
        }
      } catch (e) {}
    }
    return origPushState.apply(this, arguments);
  };
  function onlyPageParamDiffers(a, b) {
    var keys = {};
    a.searchParams.forEach(function (v, k) { if (k !== 'page') keys[k] = 1; });
    b.searchParams.forEach(function (v, k) { if (k !== 'page') keys[k] = 1; });
    for (var k in keys) { if (a.searchParams.get(k) !== b.searchParams.get(k)) return false; }
    return a.searchParams.get('page') !== b.searchParams.get('page');
  }

  if (speedMode && targetPage > 1) {
    // page=N を維持するため、CDN customization.js の「page= 削除」replaceState を一時ブロック
    var guardArmed = true;
    var guardedReplace = function (state, title, urlArg) {
      if (guardArmed && urlArg != null) {
        try {
          var next = new URL(String(urlArg), location.href);
          var cur = new URL(location.href);
          if (cur.pathname === next.pathname && cur.searchParams.get('page') && !next.searchParams.get('page')) {
            return undefined; // page= の削除だけをブロック
          }
        } catch (e) {}
      }
      return origReplaceState.apply(this, arguments);
    };
    History.prototype.replaceState = guardedReplace;
    var disarmGuard = function () {
      guardArmed = false;
      if (History.prototype.replaceState === guardedReplace) History.prototype.replaceState = origReplaceState;
      window.removeEventListener('pointerdown', disarmGuard, true);
      window.removeEventListener('keydown', disarmGuard, true);
    };
    window.addEventListener('pointerdown', disarmGuard, true);
    window.addEventListener('keydown', disarmGuard, true);
    setTimeout(disarmGuard, 8000);
    // URL の page= が消えていたら復元(reset がこのスクリプトより前に走った保険)
    if (getUrlPage() <= 1) {
      try {
        var u = new URL(location.href);
        u.searchParams.set('page', String(targetPage));
        origReplaceState.call(history, history.state, '', u.toString());
      } catch (e) {}
    }
  } else if (targetPage > 1) {
    // FULL モード: page= を外して page1 から。CDN reset は外すものが無くなり無害化
    try {
      var url = new URL(location.href);
      url.searchParams.delete('page');
      origReplaceState.call(history, history.state, '', url.toString());
    } catch (e) {}
  }

  // 過去セッションの page= が Boost の保存クエリ経由で再適用されるのを防ぐ
  try {
    var savedQs = localStorage.getItem('boostSdQueryString');
    if (savedQs && savedQs.indexOf('page=') !== -1) {
      localStorage.setItem('boostSdQueryString', savedQs.replace(/&?page=\d+/g, ''));
    }
  } catch (e) {}

  // ---- 商品カードクリックを記録(戻ってきた時の復元用) ----
  document.addEventListener('click', function (e) {
    var item = e.target && e.target.closest && e.target.closest(PRODUCT_ITEM);
    if (!item || item.closest('.boost-sd__recommendation')) return;
    if (!e.target.closest('a[href*="/products/"]')) return;
    var pid = item.getAttribute('data-product-id');
    if (!pid) return;
    try {
      // クリックした商品が「何ページ目か」を DOM 内の並び順から算出して保存。
      // これにより戻り時にそのページだけを直接読み込める(URLページより正確)。
      var list = document.querySelectorAll(PRODUCT_ITEM);
      var idx = Array.prototype.indexOf.call(list, item);
      var perPage = detectPerPage();
      var productPage = idx >= 0 && perPage > 0 ? Math.floor(idx / perPage) + 1 : getUrlPage();
      sessionStorage.setItem(RETURN_KEY, JSON.stringify({
        pid: pid,
        path: location.pathname,
        page: productPage,
        ts: Date.now()
      }));
    } catch (err) {}
  }, true);

  // 1ページあたりの件数を推定(data-total-product と total-page から、無ければ既定50)
  function detectPerPage() {
    var list = document.querySelector('.boost-sd__product-list');
    if (list) {
      var total = parseInt(list.getAttribute('data-total-product'), 10);
      var pages = parseInt(list.getAttribute('data-total-page'), 10);
      if (total > 0 && pages > 0) return Math.ceil(total / pages);
    }
    return 50;
  }

  // ユーザーの手動スクロールを検知(プログラム的な scrollIntoView とは区別するため
  // scroll ではなく wheel/touchmove/キー操作で判定)。bfcache 復帰後も生きるよう永続登録。
  var userScrolled = false;
  function markUserScroll() { userScrolled = true; enableBoostScrollTop(); }
  ['wheel', 'touchmove'].forEach(function (type) {
    window.addEventListener(type, markUserScroll, { passive: true, capture: true });
  });
  window.addEventListener('keydown', function (e) {
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ', 'Spacebar'].indexOf(e.key) !== -1) markUserScroll();
  }, true);

  // 復元中の“トップ一瞬表示”を消すためのピン留め。
  // rAF は描画直前に走るので、毎フレーム商品位置へ補正すればトップが描画されない。
  // Boost が戻り時に一旦 scrollToTop する挙動を打ち消す。ユーザーが手動スクロールしたら即解除。
  var pinRAF = null;
  function startScrollPin(pid, durationMs) {
    var deadline = performance.now() + durationMs;
    if (pinRAF) cancelAnimationFrame(pinRAF);
    function frame() {
      if (userScrolled) { pinRAF = null; return; }
      var item = findItem(pid);
      if (item) item.scrollIntoView({ block: 'center' });
      if (performance.now() < deadline) pinRAF = requestAnimationFrame(frame);
      else pinRAF = null;
    }
    pinRAF = requestAnimationFrame(frame);
  }

  function clearReturnTarget() {
    try { sessionStorage.removeItem(RETURN_KEY); } catch (e) {}
  }

  function waitFor(check, timeoutMs, intervalMs) {
    return new Promise(function (resolve) {
      var waited = 0;
      var timer = setInterval(function () {
        var result = check();
        if (result || waited >= timeoutMs) { clearInterval(timer); resolve(result || null); }
        waited += intervalMs;
      }, intervalMs);
    });
  }

  function findItem(pid) {
    var item = document.querySelector(PRODUCT_ITEM + '[data-product-id="' + pid + '"]');
    return item && !item.closest('.boost-sd__recommendation') ? item : null;
  }

  function scrollToItem(pid) {
    var item = findItem(pid);
    if (!item) return false;
    item.scrollIntoView({ block: 'center' });
    return true;
  }

  // ---- bfcache ヒット(iOS Safari で多い)。凍結 DOM のまま保存商品へ即戻す ----
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var data;
    try {
      var raw = sessionStorage.getItem(RETURN_KEY);
      if (!raw) return;
      data = JSON.parse(raw);
    } catch (err) { return; }
    if (!data || data.path !== location.pathname) return;
    userScrolled = false; // 戻ってきた直後なので手動スクロール判定をリセット
    disableBoostScrollTop(); // Boost の scrollToTop を抑止(popstate と二重の保険)
    setTimeout(enableBoostScrollTop, 1500);
    scrollToItem(data.pid);
    startScrollPin(data.pid, 800); // トップ一瞬表示を消しつつ商品位置を保持
    clearReturnTarget();
  });

  function visibleButton(sel) {
    var btn = document.querySelector(sel);
    if (!btn) return null;
    var container = btn.closest('[data-position]') || btn;
    if (getComputedStyle(container).display === 'none') return null;
    return btn;
  }

  // 「もっと見る」を目標ページまで自動クリック(FULL モード用・下方向 append)
  function loadMoreUpTo(pages, pid) {
    var loaded = 1;
    function step() {
      if (loaded >= pages) return Promise.resolve();
      return waitFor(function () { return visibleButton(LOAD_MORE_BTN); }, 5000, 100).then(function (btn) {
        if (!btn) return;
        var before = document.querySelectorAll(PRODUCT_ITEM).length;
        btn.click();
        return waitFor(function () { return document.querySelectorAll(PRODUCT_ITEM).length > before; }, 10000, 100)
          .then(function (ok) {
            if (!ok) return;
            loaded++;
            if (pid) scrollToItem(pid);
            return new Promise(function (r) { setTimeout(r, 120); }).then(step);
          });
      });
    }
    return step();
  }

  // SPEED フォールバック: 目標ページに商品が無い(古いページの商品をクリックしていた等)場合、
  // 「前のページを読み込む」を数回押して商品を探す。スクロール位置は自前で補正。
  function loadPrevUntilFound(pid, maxTries) {
    var tries = 0;
    function step() {
      if (findItem(pid) || tries >= maxTries) return Promise.resolve();
      var btn = visibleButton(LOAD_PREV_BTN);
      if (!btn) return Promise.resolve();
      tries++;
      var anchor = document.querySelector(PRODUCT_ITEM);
      var before = anchor ? anchor.getBoundingClientRect().top + window.scrollY : null;
      var count = document.querySelectorAll(PRODUCT_ITEM).length;
      btn.click();
      return waitFor(function () { return document.querySelectorAll(PRODUCT_ITEM).length > count; }, 10000, 100)
        .then(function (ok) {
          if (anchor && anchor.isConnected && before !== null) {
            var after = anchor.getBoundingClientRect().top + window.scrollY;
            if (after !== before) window.scrollBy(0, after - before);
          }
          if (!ok) return;
          return new Promise(function (r) { setTimeout(r, 120); }).then(step);
        });
    }
    return step();
  }

  function init() {
    if (!speedMode && targetPage <= 1) return;

    // SPEED: 商品が描画され次第フレーム毎に中央保持を始める。これにより、
    // 出現の瞬間から描画直前に位置が確定し「トップを一瞬描画→スクロール」が起きない。
    if (speedMode) startScrollPin(returnTarget.pid, 3000);

    waitFor(function () { return document.querySelector(PRODUCT_ITEM); }, 20000, 100).then(function (first) {
      if (!first) return;

      if (speedMode) {
        if (findItem(returnTarget.pid)) { clearReturnTarget(); return; }
        // 見つからない(古いページの商品) → 前のページを遡って探す
        loadPrevUntilFound(returnTarget.pid, MAX_AUTO_PAGES).then(function () {
          startScrollPin(returnTarget.pid, 1000);
          clearReturnTarget();
        });
      } else {
        // FULL: page1..N を全部表示
        loadMoreUpTo(targetPage, null).then(function () { clearReturnTarget(); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
